import { createContext } from 'react';

import { ProtectPolicyFragment } from '@graphql/requests';

import { ReservationAgreementQuestionnaireData } from '@ui-furniture/common/questionnaires/use-ra-questionnaire';

export const RAContext = createContext<{
  createDraftPolicy: (
    data: ReservationAgreementQuestionnaireData
  ) => Promise<ProtectPolicyFragment>;
  isCreating: boolean;
} | null>(null);
